import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
import { Watermark } from './Watermark';
const GOLD = '#C9A96E';
export function Hero() {
  return <section className="relative min-h-[90vh] flex items-center justify-center bg-nude-light overflow-hidden px-6 py-24" data-id="element-112" data-mp="9kjwmolen43o">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-113" data-mp="4jm4pkalevoz">
        <div className="absolute top-[-10%] left-[-5%] w-96 h-96 bg-rosado-soft rounded-full mix-blend-multiply filter blur-3xl opacity-70" data-id="element-114" data-mp="128pg780q2n1x"></div>
        <div className="absolute bottom-[-10%] right-[-5%] w-96 h-96 bg-nude rounded-full mix-blend-multiply filter blur-3xl opacity-70" data-id="element-115" data-mp="sartioyigybf"></div>
      </div>

      {/* Subtle brand watermark behind the headline */}
      <Watermark position="center" size={900} opacity={0.06} data-id="element-116" data-mp="3d1sa6w93nhsl" />

      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-117" data-mp="382fgbrjt9agi">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-118" data-mp="3814cxsua24px">
          <h2 className="text-sm md:text-base font-sans tracking-[0.3em] uppercase mb-5" style={{
          color: GOLD
        }} data-id="element-119" data-mp="39aupza1hhgvn">
            ALEXA BEAUTY{' '}
            <span className="font-light tracking-[0.2em]" data-id="element-120" data-mp="30hrgfctylo6a">
              Brows And Lashes
            </span>
          </h2>

          <h1 className="text-[2.5rem] md:text-6xl lg:text-7xl font-serif font-medium text-luxury-black leading-tight mb-4" data-id="element-121" data-mp="359j8xswoe3z2">
            TODO LO QUE NECESITAS PARA PESTAÑAS, EN UN SOLO KIT.
          </h1>

          {/* Decorative gold line */}
          <motion.div initial={{
          scaleX: 0
        }} animate={{
          scaleX: 1
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} className="mx-auto mb-8 h-[1px] w-24 origin-center" style={{
          backgroundColor: GOLD
        }} data-id="element-122" data-mp="2hj5e5umphr0s" />

          <p className="text-lg md:text-xl text-gray-600 font-sans font-light max-w-2xl mx-auto mb-14 leading-relaxed" data-id="element-123" data-mp="n9i35afexat2">
            <span style={{
            color: GOLD
          }} className="font-normal" data-id="element-124" data-mp="ddf082cql852">
              Organiza
            </span>{' '}
            tu trabajo,{' '}
            <span style={{
            color: GOLD
          }} className="font-normal" data-id="element-125" data-mp="161jcj6ptcjgq">
              ahorra tiempo
            </span>{' '}
            y proyecta una{' '}
            <span style={{
            color: GOLD
          }} className="font-normal" data-id="element-126" data-mp="x0cu2s3lsyku">
              imagen profesional
            </span>{' '}
            con un kit diseñado para tener todo bajo control, sin
            complicaciones.
          </p>

          <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 text-sm text-gray-500 font-sans mb-12" data-id="element-127" data-mp="1xaw06rmvemay">
            <motion.span whileHover={{
            scale: 1.05
          }} className="flex items-center gap-2 cursor-default transition-colors duration-300" data-id="element-128" data-mp="269zivui4kzox">
              <SparklesIcon className="w-4 h-4 transition-all duration-300" style={{
              color: GOLD
            }} data-id="element-129" data-mp="2g02kgj3bblyv" />
              Elegancia en cada detalle
            </motion.span>
            <motion.span whileHover={{
            scale: 1.05
          }} className="flex items-center gap-2 cursor-default transition-colors duration-300" data-id="element-130" data-mp="2p10fibvrwj5b">
              <SparklesIcon className="w-4 h-4 transition-all duration-300" style={{
              color: GOLD
            }} data-id="element-131" data-mp="uoallu5en9xx" />
              Organización sin esfuerzo
            </motion.span>
            <motion.span whileHover={{
            scale: 1.05
          }} className="flex items-center gap-2 cursor-default transition-colors duration-300" data-id="element-132" data-mp="3vi6y0jozo8t5">
              <SparklesIcon className="w-4 h-4 transition-all duration-300" style={{
              color: GOLD
            }} data-id="element-133" data-mp="9a7c9dt1marf" />
              Diseñado para resultados profesionales
            </motion.span>
          </div>

          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 1,
          delay: 0.8
        }} className="text-base md:text-lg text-luxury-dark/80 font-serif italic max-w-xl mx-auto leading-relaxed" data-id="element-134" data-mp="3rftsnwe5mcww">
            Trabaja con más seguridad, más orden y más{' '}
            <span style={{
            color: GOLD
          }} className="not-italic font-medium" data-id="element-135" data-mp="19hm7jx4ca4hw">
              confianza
            </span>
            … todo empieza con tener lo correcto contigo.
          </motion.p>
        </motion.div>
      </div>
    </section>;
}